/**
 * jQuery Modal
 * Copyright © 2018, Alexander Griffioen <mail@oscaralexander.com>
 * Published under MIT license.
 */

const pluginName = 'modal'

class Modal {
    constructor(el, options) {
        this.$el = $(el)
        this.options = $.extend({}, this.defaults, options)
        this.init()
    }

    close() {
        // Reset forms
        this.$el.find('form').each((i, form) => {
            form.reset()
        })

        // Reset steps
        this.$el.attr(this.options.attrStep, 1)

        $('body').removeClass(this.options.classNameHasModal)
        this.$el.removeClass(this.options.classNameIsVisible).trigger(this.eventNameClose)
    }

    closeAll() {
        $('body').removeClass(this.options.classNameHasModal)
        $(this.selector).modal('close')
    }

    init() {
        this.name = this.$el.attr(this.options.attrName)
        this.step = this.$el.attr(this.options.attrStep) || 1

        $('body').on('click', `[data-modal-show='${this.name}'], a[href='#modal-${this.name}']`, this.onOpen.bind(this))
        
        // Close modal when Esc key is pressed.
        $('body').on('keydown', (e) => {
            if (e.keyCode === 27) {
                this.close()
            }
        })

        // Close modal when close icon is clicked.
        $(this.options.selectorBack, this.$el).on('click', this.onBack.bind(this))

        // Close modal when close icon is clicked.
        $(this.options.selectorClose, this.$el).on('click', this.onClose.bind(this))

        // Close modal when overlay is clicked.
        /*
        this.$el.on('click', (e) => {
            if (e.target === e.currentTarget) {
                this.close()
            }
        })
        */
    }

    onBack(e) {
        e.preventDefault()

        let step = parseInt(this.$el.attr(this.options.attrStep) || 1)

        if (this.step > 1) {
            this.$el.attr(this.options.attrStep, step - 1)
        }
    }

    onClose(e) {
        e.preventDefault()
        this.close()
    }

    onOpen(e) {
        e.preventDefault()
        this.open()
    }

    open() {
        this.closeAll()
        this.$el.addClass(this.options.classNameIsVisible)
        $('body').addClass(this.options.classNameHasModal)

        setTimeout(() => {
            this.$el.trigger(this.options.eventNameOpen)
        }, 10)
    }
}

Modal.prototype.defaults = {
    attrName: 'data-modal',
    attrStep: 'data-modal-step',
    classNameHasModal: 'has-modal',
    classNameIsVisible: 'is-visible',
    eventNameClose: 'modal:close',
    eventNameOpen: 'modal:open',
    selector: '.js-modal',
    selectorBack: '.js-modalBack',
    selectorClose: '.js-modalClose',
}

$.fn[pluginName] = function (options) {
    return this.each(function () {
        let instance = $(this).data(`plugin_${pluginName}`)

        if (!instance) {
            $(this).data(`plugin_${pluginName}`, new Modal(this, options))
        } else {
            if (typeof options === 'string') {
                instance[options]()
            }
        }
    })
}